// Example usage for different courses
import React from "react";
import CoursePage from "../Components/CoursePage";

// For C Programming Course
export const CProgramming = () => {
  const cProgrammingContent = {
    courseTitle: "C Programming",
    courseDescription: "Learn programming concepts, logic building, and software development using modern programming languages.",
    breadcrumbText: "C Programming",
    
    courseContents: [
      { 
        id: 1, 
        title: "Basics of C Programming", 
        items: [
          "Structure of C Programming",
          "Writing a C Programs",
          "Build and Execute a C Programs",
          "Debugging a C Program"
        ] 
      },
      { 
        id: 2, 
        title: "Data Types and Variables", 
        items: [
          "Declaring and Initializing a variables",
          "Operators, Operands, and Expression"
        ] 
      },
      { 
        id: 3, 
        title: "Control Flow Statements", 
        items: [
          "Control-Flow Program Statements",
          "Looping",
          "Formatted IO Functions",
          "Basics of Input/Output Concepts",
          "Formatted Input Function"
        ] 
      },
      { 
        id: 4, 
        title: "Functions and Program Structure", 
        items: [
          "Basics of Function",
          "Scope Rules",
          "Header Files",
          "Static Variables",
          "Passing arguments",
          "Standard Library Functions"
        ] 
      },
      { 
        id: 5, 
        title: "Arrays, Pointers and String", 
        items: [
          "Pointers and Addresses",
          "Structures",
          "Arrays of Structures",
          "Passing Structures to Functions",
          "Nesting Structures"
        ] 
      },
      { 
        id: 6, 
        title: "File Operations", 
        items: [
          "Understanding ASCII and binary files",
          "Understanding FILE structure",
          "Understanding stdin, stdout and stderr",
          "Creating and opening files",
          "Read and write data in text and binary format",
          "Writing own file copy functions"
        ] 
      }
    ],
    
    courseOverview: {
      title: "C Programming Overview",
      description: "<b>C is a structured based programming language.</b> It is a machine-independent and interpreter language which is widely used to develop an operating system and graphical-based application. CAD DESK's online training course is designed in such a way that it will help beginners to understand the working of the C programming language and creating various functions, arrays, and structures in C.<br /><br />Learning C programming language can build a base for many programming languages. C is simple and easy to learn; is highly portable which means it can be compiled on a variety of computer systems. CAD DESK promotes the students to do Internships and provides them projects to work on along with the best quality training.<br /><br />Moreover, CAD DESK provides students to have free lifetime access to recorded video tutorials and login access to their dashboard. Students can visit any of our CAD centers for revision coaching classes even after completing the course. CAD DESK certificate enhances the job opportunities for its students and provides great recognition in the industry."
    },
    
    sidebarImage: "img/programming.webp"
  };

  return <CoursePage {...cProgrammingContent} />;
};

// For Accounting Course
export const Accounting = () => {
  const accountingContent = {
    courseTitle: "Accounting Fundamentals",
    courseDescription: "Learn accounting fundamentals including bookkeeping, financial statements, and accounting software.",
    breadcrumbText: "Accounting",
    
    courseContents: [
      { 
        id: 1, 
        title: "Introduction to Accounting", 
        items: [
          "Basics of Accounting",
          "Principles of Accounting",
          "Accounting Concepts and Conventions",
          "Types of Accounts"
        ] 
      },
      { 
        id: 2, 
        title: "Bookkeeping", 
        items: [
          "Journal Entries",
          "Ledger Posting",
          "Trial Balance",
          "Cash Book"
        ] 
      },
      { 
        id: 3, 
        title: "Financial Statements", 
        items: [
          "Income Statement",
          "Balance Sheet",
          "Cash Flow Statement",
          "Funds Flow Statement"
        ] 
      },
      { 
        id: 4, 
        title: "Accounting Software", 
        items: [
          "Introduction to Tally",
          "Creating Company",
          "Recording Transactions",
          "Generating Reports"
        ] 
      }
    ],
    
    courseOverview: {
      title: "Accounting Overview",
      description: "<b>Master the fundamentals of accounting.</b> This comprehensive course covers everything from basic bookkeeping to advanced financial statements. Learn how to maintain accurate financial records, understand accounting principles, and use modern accounting software.<br /><br />Our expert instructors will guide you through real-world scenarios and practical exercises. You'll gain hands-on experience with industry-standard accounting tools and techniques.<br /><br />CAD DESK provides lifetime access to course materials, recorded sessions, and regular doubt-clearing sessions. Get certified and enhance your career prospects in the accounting field."
    },
    
    sidebarImage: "img/accounting.webp"
  };

  return <CoursePage {...accountingContent} />;
};

// For Graphic Design Course
export const GraphicDesign = () => {
  const graphicDesignContent = {
    courseTitle: "Graphic Design",
    courseDescription: "Learn visual communication, typography, color theory, and digital design tools.",
    breadcrumbText: "Graphic Design",
    
    courseContents: [
      { 
        id: 1, 
        title: "Design Fundamentals", 
        items: [
          "Elements of Design",
          "Principles of Design",
          "Color Theory",
          "Typography Basics"
        ] 
      },
      { 
        id: 2, 
        title: "Adobe Photoshop", 
        items: [
          "Interface Overview",
          "Image Editing",
          "Layer Management",
          "Photo Retouching",
          "Masking Techniques"
        ] 
      },
      { 
        id: 3, 
        title: "Adobe Illustrator", 
        items: [
          "Vector Graphics",
          "Logo Design",
          "Illustration Techniques",
          "Typography Design"
        ] 
      },
      { 
        id: 4, 
        title: "Layout Design", 
        items: [
          "Brochure Design",
          "Poster Design",
          "Business Card Design",
          "Magazine Layout"
        ] 
      }
    ],
    
    courseOverview: {
      title: "Graphic Design Overview",
      description: "<b>Unlock your creative potential with our Graphic Design course.</b> Learn the fundamentals of visual communication, master industry-standard tools, and create stunning designs for print and digital media.<br /><br />This comprehensive course covers everything from design theory to practical application. You'll work on real-world projects and build a professional portfolio.<br /><br />CAD DESK offers expert guidance, lifetime access to learning materials, and industry-recognized certification to help you start your career in graphic design."
    },
    
    sidebarImage: "img/graphic-design.webp"
  };

  return <CoursePage {...graphicDesignContent} />;
};


// For Data Visualisation Course
export const DataVisualisation = () => {
  const dataVizContent = {
    courseTitle: "Data Visualisation",
    courseDescription: "Learn how to represent data visually using charts, dashboards, and data analytics tools.",
    breadcrumbText: "Data Visualisation",
    
    courseContents: [
      { 
        id: 1, 
        title: "Introduction to Business Intelligence", 
        items: [
          "Introduction to Tools and Terminology",
          "Overview of Dashboard",
          "Data Visualization & Reporting",
          "Business Intelligence (BI), Traditional BI, Self-Serviced BI",
          "Power BI Desktop (Power Query, Power Pivot, Power View)",
          "Power BI Report Server, Power BI Service, Power BI Mobile Flow",
          "Work in Power BI / Power BI Architecture"
        ] 
      },
      { 
        id: 2, 
        title: "Basics of Excel and Database", 
        items: [
          "Basics of Excel",
          "Basics of SQL Server",
          "Data from multiple Data Sources"
        ] 
      },
      { 
        id: 3, 
        title: "Power Query", 
        items: [
          "Data Transformation, Benefits of Data Transformation",
          "Overview of Power Query / Query Editor, Query Editor User Interface",
          "Ribbon (Home, Transform, Add Column, View Tabs)",
          "The Data View / Results Pane, The Query Settings Pane, Formula Bar",
          "Data types, changing the Data type of a Column Filter",
          "Auto Filter / Basic Filtering",
          "PIVOT, UNPIVOT Columns",
          "Transpose Columns",
          "Header Row or Use First Row as Headers",
          "Group Rows / Group By",
          "M Language",
          "IF and ELSE Conditions, Transform Column () Types",
          "Remove Columns (), Split Columns (), Replace Value()",
          "Distinct Options and GROUP BY Options Table",
          "Group (), Table. Sort () with Type Conversions PIVOT",
          "Operation and Table. Pivot (), List Functions",
          "Parameters with M Language"
        ] 
      },
      { 
        id: 4, 
        title: "Data Modeling", 
        items: [
          "Data Modeling Introduction",
          "Relationship, Need of Relationship",
          "One-to-One, One-to-Many (or Many-to-One), Many-to-Many",
          "AutoDetect the relationship, Create a new relationship, Edit existing relationships",
          "Make Relationship Active or Inactive"
        ] 
      },
      { 
        id: 5, 
        title: "DAX (Data Analysis Expressions)", 
        items: [
          "What is DAX, Calculated Column, Measures",
          "DAX Table and Column Name Syntax",
          "Creating Calculated Columns, Creating Measures Calculated",
          "DAX Syntax & Operators",
          "DAX Operators",
          "DAX Function"
        ] 
      },
      { 
        id: 6, 
        title: "DAX Functions", 
        items: [
          "Date and Time Functions: YEAR, MONTH, DAY, WEEKDAY, WEEKNUM",
          "FORMAT (Text Function) - Month Name, Weekday Name",
          "DATE, TODAY, NOW, HOUR, MINUTE, SECOND, TIME",
          "DATEDIFF, CALENDAR",
          "Text Functions: LEN, CONCATENATE, LEFT, RIGHT, MID",
          "UPPER, LOWER, TRIM, SUBSTITUTE, BLANK",
          "Logical Functions: IF, TRUE, FALSE, NOT, OR, IN, AND, IFERROR, SWITCH",
          "Math & Statistical Functions",
          "Filter Functions"
        ] 
      },
      { 
        id: 7, 
        title: "Visualizations", 
        items: [
          "Visualizing Data, Why Visualizations",
          "Visualization types, Create and Format Bar and Column Charts",
          "Create and Format Stacked Bar Chart, Stacked Column Chart",
          "Create and Format Scatter Charts",
          "Create and Format Table Visual, Matrix Visualization",
          "Create and Format Line Chart, Area Chart, Stacked Area Chart",
          "Create and Format Line and Stacked Column Chart, Line and Clustered Column Chart"
        ] 
      }
    ],
    
    courseOverview: {
      title: "Data Visualisation Overview",
      description: "<b>Power BI is a business intelligence and data visualization application that transforms information from many data sources into interactive dashboards and reports.</b> Power BI desktop, Power BI service based on SaaS, and mobile Power BI apps accessible for various platforms are all part of the Power BI package, which offers a variety of products, connectors, and services. Business customers utilize this group of services to gather data and create BI reports.<br /><br />Reports are created using the Power BI desktop programme, published using the Power BI Services (Software as a Service – SaaS), and viewed using the Power BI mobile app.<br /><br />CAD DESK provides hands-on training, real-world projects, and certification to boost your career in data analytics."
    },
    
    sidebarImage: "img/data-visualisation.webp"
  };

  return <CoursePage {...dataVizContent} />;
};

// For Software Testing Course
export const SoftwareTesting = () => {
  const testingContent = {
    courseTitle: "Software Testing",
    courseDescription: "Understand software testing methodologies including manual and automated testing techniques.",
    breadcrumbText: "Software Testing",
    
    courseContents: [
      { 
        id: 1, 
        title: "Testing Fundamentals", 
        items: [
          "Software Development Life Cycle",
          "Testing Life Cycle",
          "Types of Testing",
          "Test Planning"
        ] 
      },
      { 
        id: 2, 
        title: "Manual Testing", 
        items: [
          "Test Case Design",
          "Test Execution",
          "Defect Tracking",
          "Regression Testing"
        ] 
      },
      { 
        id: 3, 
        title: "Automation Testing", 
        items: [
          "Introduction to Selenium",
          "WebDriver Basics",
          "TestNG Framework",
          "Page Object Model"
        ] 
      },
      { 
        id: 4, 
        title: "Performance Testing", 
        items: [
          "Load Testing",
          "Stress Testing",
          "JMeter Basics",
          "Performance Analysis"
        ] 
      }
    ],
    
    courseOverview: {
      title: "Software Testing Overview",
      description: "<b>Ensure software quality with comprehensive testing skills.</b> Learn both manual and automated testing methodologies used in the industry. Master tools like Selenium and JMeter.<br /><br />This course covers the entire testing lifecycle from test planning to execution and reporting. You'll gain practical experience through hands-on projects.<br /><br />CAD DESK offers expert training, lifetime access to materials, and certification to help you become a skilled software testing professional."
    },
    
    sidebarImage: "img/software-testing.webp"
  };

  return <CoursePage {...testingContent} />;
};

// For Web Development Course
export const WebDevelopment = () => {
  const webDevContent = {
    courseTitle: "Web Development",
    courseDescription: "Learn how to build modern websites using HTML, CSS, JavaScript and backend technologies.",
    breadcrumbText: "Web Development",
    
    courseContents: [
      { 
        id: 1, 
        title: "Frontend Basics", 
        items: [
          "HTML5 Fundamentals",
          "CSS3 Styling",
          "Responsive Design",
          "CSS Frameworks"
        ] 
      },
      { 
        id: 2, 
        title: "JavaScript", 
        items: [
          "JavaScript Basics",
          "DOM Manipulation",
          "ES6 Features",
          "Async Programming"
        ] 
      },
      { 
        id: 3, 
        title: "Backend Development", 
        items: [
          "Node.js Basics",
          "Express Framework",
          "RESTful APIs",
          "Database Integration"
        ] 
      },
      { 
        id: 4, 
        title: "Full Stack Projects", 
        items: [
          "MERN Stack Overview",
          "Building Complete Applications",
          "Deployment",
          "Project Management"
        ] 
      }
    ],
    
    courseOverview: {
      title: "Web Development Overview",
      description: "<b>Become a full-stack web developer.</b> Learn to build modern, responsive websites from scratch. Master frontend technologies like HTML, CSS, and JavaScript, and backend frameworks like Node.js.<br /><br />This comprehensive course takes you from beginner to professional web developer. You'll build real-world projects and create a portfolio to showcase your skills.<br /><br />CAD DESK provides expert mentorship, lifetime access to resources, and certification to launch your career in web development."
    },
    
    sidebarImage: "img/web-development.webp"
  };

  return <CoursePage {...webDevContent} />;
};

// For Database Management Course
export const DatabaseManagement = () => {
  const dbContent = {
    courseTitle: "Database Management",
    courseDescription: "Learn database design, SQL queries, data storage, and management of relational databases.",
    breadcrumbText: "Database Management",
    
    courseContents: [
      { 
        id: 1, 
        title: "Introduction to DBMS and RDBMS", 
        items: [
          "Database Management System (DBMS) and Data Models",
          "Hierarchical Data Model (HDBMS) and Network Data Model (NDBMS)",
          "Relational Data Model (RDBMS) and Object Data Model(ODBMS)"
        ] 
      },
      { 
        id: 2, 
        title: "Introduction to SQL Server", 
        items: [
          "History and features of SQL Server",
          "Types of TSQL commands: Data Definition Language (DDL), Data Manipulation Language (DML), Data Query Language (DQL), Data Control Language (DCL), Transaction Control Language (TCL)"
        ] 
      },
      { 
        id: 3, 
        title: "Data Manipulation Language", 
        items: [
          "SELECT statement: querying data from tables",
          "INSERT, UPDATE, and DELETE statements",
          "Using WHERE clause for filtering data",
          "Sorting and limiting query results"
        ] 
      },
      { 
        id: 4, 
        title: "Data Definition Language (DDL)", 
        items: [
          "Creating and altering database objects (tables, views, indexes, etc.)",
          "Constraints: types and usage (Primary key, Foreign key, Unique, Check, Default)",
          "Managing database schemas"
        ] 
      },
      { 
        id: 5, 
        title: "Joins and Subqueries", 
        items: [
          "Understanding different types of joins (INNER, LEFT, RIGHT, FULL)",
          "Self Join, Cross Join and Equi Join",
          "Writing subqueries to retrieve data",
          "Combining multiple queries using UNION, INTERSECT, and EXCEPT"
        ] 
      },
      { 
        id: 6, 
        title: "Indexes and Views", 
        items: [
          "Clustered Index",
          "NonClustered Index",
          "Create, Alter and Drop Indexes",
          "Using Indexes",
          "Creating, Altering and Dropping Views",
          "Simple and Complex Views",
          "Encryption and Schema Binding Options in creating views"
        ] 
      },
      { 
        id: 7, 
        title: "Transact-SQL (T-SQL)", 
        items: [
          "Scripts and Batches Declaring Variables",
          "Using Statements",
          "Working with Temp Tables",
          "Error Handling",
          "Using System Functions / Global Variables",
          "Using Dynamic SQL"
        ] 
      },
      { 
        id: 8, 
        title: "Working with Stored Procedures and Functions", 
        items: [
          "Introduction to stored procedures",
          "Benefits of Stored Procedures",
          "Creating, Executing, Modifying, Dropping",
          "Input–Output and Optional Parameters",
          "System defined SP's and Functions",
          "User defined Functions"
        ] 
      },
      { 
        id: 9, 
        title: "Implementing Triggers", 
        items: [
          "Introduction to triggers",
          "Constraints vs Triggers",
          "Creating, Altering, Dropping triggers",
          "for/after/instead of triggers",
          "Using Rollback Tran"
        ] 
      },
      { 
        id: 10, 
        title: "Working with Cursors and Transactions", 
        items: [
          "Creating Cursors",
          "Cursors vs. Select",
          "Types of cursors",
          "Locks on cursors",
          "Introduction of Transaction",
          "Types of transactions (Implicit, explicit)",
          "Working with Locks, Types of locks"
        ] 
      }
    ],
    
    courseOverview: {
      title: "Database Management Overview",
      description: "<b>Master the art of data management.</b> Learn to design, implement, and maintain databases using industry-standard practices. From basic SQL to advanced database administration.<br /><br />This course covers everything you need to become a database professional. You'll work with real-world scenarios and gain hands-on experience.<br /><br />CAD DESK offers comprehensive training, lifetime access to materials, and certification to advance your career in database management."
    },
    
    sidebarImage: "img/database-management.webp"
  };

  return <CoursePage {...dbContent} />;
};

// For UI & UX Course
export const UIUX = () => {
  const uiuxContent = {
    courseTitle: "UI & UX Design",
    courseDescription: "Learn user interface and user experience design principles to create user-friendly digital products.",
    breadcrumbText: "UI & UX",
    
    courseContents: [
      { 
        id: 1, 
        title: "UX Fundamentals", 
        items: [
          "Introduction to UX",
          "User Research",
          "User Personas",
          "User Journey Mapping"
        ] 
      },
      { 
        id: 2, 
        title: "UI Design Principles", 
        items: [
          "Visual Hierarchy",
          "Color Theory",
          "Typography in UI",
          "Layout and Composition"
        ] 
      },
      { 
        id: 3, 
        title: "Wireframing & Prototyping", 
        items: [
          "Low-fidelity Wireframes",
          "High-fidelity Mockups",
          "Interactive Prototypes",
          "Usability Testing"
        ] 
      },
      { 
        id: 4, 
        title: "Design Tools", 
        items: [
          "Figma Basics",
          "Adobe XD",
          "Sketch",
          "Design Systems"
        ] 
      }
    ],
    
    courseOverview: {
      title: "UI & UX Overview",
      description: "<b>Create exceptional user experiences.</b> Learn the principles and practices of user interface and user experience design. Master industry-standard tools and techniques.<br /><br />This course combines theory with practical application. You'll work on real projects and build a portfolio that showcases your design skills.<br /><br />CAD DESK provides expert guidance, lifetime access to learning materials, and certification to help you start your career in UI/UX design."
    },
    
    sidebarImage: "img/ui-ux.webp"
  };

  return <CoursePage {...uiuxContent} />;
};

// For PhotoShop Course
export const PhotoShop = () => {
  const photoshopContent = {
    courseTitle: "Adobe Photoshop",
    courseDescription: "Graphic design software used for enhancing and editing images, including architectural visualizations.",
    breadcrumbText: "PhotoShop",
    
    courseContents: [
      { 
        id: 1, 
        title: "Getting Started", 
        items: [
          "Photoshop Workspace",
          "Importing",
          "Working with Layers",
          "Selecting and Transforming"
        ] 
      },
      { 
        id: 2, 
        title: "Essential Tools", 
        items: [
          "Brushes with Masks",
          "Fill and Paint Bucket Tool",
          "Shape Tool",
          "Custom Shapes"
        ] 
      },
      { 
        id: 3, 
        title: "Advanced Techniques", 
        items: [
          "Clone Stamp Tool",
          "Collaging & Editing Drawings"
        ] 
      }
    ],
    
    courseOverview: {
      title: "Photoshop Overview",
      description: "<b>Adobe Photoshop is one of the best photo editing programs.</b> It can be easily used in both Windows and macOS computers. With a variety of features and tools, the use of Adobe Photoshop is highly recommended by designers, web developers, graphic artists, photographers, and creative professionals. CAD DESK's online training course provides a great opportunity to consolidate your learning and ensure you use the new skills to your fullest potential when working on your projects.<br /><br />Adobe Photoshop is the most used software tool for editing photos, image manipulation, and retouching for bulk images and video file formats. The tools available within Photoshop, make it possible to edit both single photos as well as large batches of photos. CAD DESK gives a boost to students' careers and encourages them to do Internships and learn from the projects through great quality training.<br /><br />In addition, CAD DESK students get free lifetime access to recorded video tutorials and login access to their student dashboard; and also, they can visit any of our CAD centers for the offline practice session. CAD DESK certificate facilitates its students to escalate their careers, increase their level of expertise, and help them to grab the best job opportunities in the industry."
    },
    
    sidebarImage: "img/photoshop.webp"
  };

  return <CoursePage {...photoshopContent} />;
};

// For Corel Draw Course
export const CorelDraw = () => {
  const corelContent = {
    courseTitle: "CorelDraw",
    courseDescription: "Learn vector graphic design, illustration, and professional layout design using CorelDraw.",
    breadcrumbText: "Corel Draw",
    
    courseContents: [
      { 
        id: 1, 
        title: "CorelDraw Basics", 
        items: [
          "Interface Overview",
          "Workspace Setup",
          "Basic Tools",
          "Document Setup"
        ] 
      },
      { 
        id: 2, 
        title: "Vector Graphics", 
        items: [
          "Drawing Shapes",
          "Working with Curves",
          "Node Editing",
          "Color Management"
        ] 
      },
      { 
        id: 3, 
        title: "Text and Typography", 
        items: [
          "Artistic Text",
          "Paragraph Text",
          "Text Effects",
          "Typography Design"
        ] 
      },
      { 
        id: 4, 
        title: "Layout Design", 
        items: [
          "Logo Design",
          "Brochure Design",
          "Business Cards",
          "Export Options"
        ] 
      }
    ],
    
    courseOverview: {
      title: "CorelDraw Overview",
      description: "<b>Create stunning vector graphics and layouts.</b> Learn CorelDraw, the powerful design software used by professionals worldwide. Perfect for logo design, illustration, and print projects.<br /><br />This course takes you from beginner to expert in vector design. You'll create professional projects and build a strong portfolio.<br /><br />CAD DESK offers expert training, lifetime access to materials, and certification to launch your design career."
    },
    
    sidebarImage: "img/corel-draw.webp"
  };

  return <CoursePage {...corelContent} />;
};

// For Canva Course
export const Canva = () => {
  const canvaContent = {
    courseTitle: "Canva Design",
    courseDescription: "Create professional graphics, social media designs, and presentations using Canva.",
    breadcrumbText: "Canva",
    
    courseContents: [
      { 
        id: 1, 
        title: "Canva Basics", 
        items: [
          "Getting Started",
          "Interface Overview",
          "Templates",
          "Design Setup"
        ] 
      },
      { 
        id: 2, 
        title: "Design Elements", 
        items: [
          "Working with Text",
          "Photos and Graphics",
          "Elements and Icons",
          "Backgrounds"
        ] 
      },
      { 
        id: 3, 
        title: "Social Media Design", 
        items: [
          "Instagram Posts",
          "Facebook Covers",
          "YouTube Thumbnails",
          "Story Designs"
        ] 
      },
      { 
        id: 4, 
        title: "Advanced Features", 
        items: [
          "Animations",
          "Brand Kit",
          "Collaboration",
          "Export Options"
        ] 
      }
    ],
    
    courseOverview: {
      title: "Canva Overview",
      description: "<b>Design like a pro with Canva.</b> Learn to create stunning graphics for social media, marketing, and presentations. No design experience required.<br /><br />This course covers everything from basic designs to advanced animations. You'll learn to create professional-looking content quickly and easily.<br /><br />CAD DESK provides practical training, lifetime access to resources, and certification to enhance your digital design skills."
    },
    
    sidebarImage: "img/canva.webp"
  };

  return <CoursePage {...canvaContent} />;
};

// For CSS Course
export const CSS = () => {
  const cssContent = {
    courseTitle: "CSS",
    courseDescription: "Learn Cascading Style Sheets to design responsive and visually appealing websites.",
    breadcrumbText: "CSS",
    
    courseContents: [
      { 
        id: 1, 
        title: "CSS Fundamentals", 
        items: [
          "Introduction to CSS",
          "Selectors and Properties",
          "Box Model",
          "Colors and Backgrounds"
        ] 
      },
      { 
        id: 2, 
        title: "Typography and Styling", 
        items: [
          "Font Properties",
          "Text Styling",
          "Lists and Links",
          "Tables"
        ] 
      },
      { 
        id: 3, 
        title: "Layout Techniques", 
        items: [
          "Display and Positioning",
          "Flexbox",
          "CSS Grid",
          "Floats and Clearfix"
        ] 
      },
      { 
        id: 4, 
        title: "Responsive Design", 
        items: [
          "Media Queries",
          "Mobile-First Design",
          "Responsive Images",
          "Viewport Units"
        ] 
      }
    ],
    
    courseOverview: {
      title: "CSS Overview",
      description: "<b>Master modern CSS techniques.</b> Learn to create beautiful, responsive websites with Cascading Style Sheets. From basics to advanced layouts.<br /><br />This course covers everything from selectors to Flexbox and Grid. You'll build responsive designs that work on all devices.<br /><br />CAD DESK provides hands-on training, lifetime access to materials, and certification to boost your web development career."
    },
    
    sidebarImage: "img/css.webp"
  };

  return <CoursePage {...cssContent} />;
};

// For Figma Course
export const Figma = () => {
  const figmaContent = {
    courseTitle: "Figma Design",
    courseDescription: "Learn interface design, prototyping, and collaborative design using Figma.",
    breadcrumbText: "Figma",
    
    courseContents: [
      { 
        id: 1, 
        title: "Figma Basics", 
        items: [
          "Getting Started",
          "Interface Overview",
          "Frames and Shapes",
          "Vector Tools"
        ] 
      },
      { 
        id: 2, 
        title: "Design Systems", 
        items: [
          "Components and Instances",
          "Styles and Variables",
          "Auto Layout",
          "Constraints"
        ] 
      },
      { 
        id: 3, 
        title: "Prototyping", 
        items: [
          "Creating Connections",
          "Interactive Components",
          "Animations",
          "User Flows"
        ] 
      },
      { 
        id: 4, 
        title: "Collaboration", 
        items: [
          "Team Libraries",
          "Comments and Feedback",
          "Version History",
          "Developer Handoff"
        ] 
      }
    ],
    
    courseOverview: {
      title: "Figma Overview",
      description: "<b>Design and prototype with Figma.</b> Learn the industry's favorite collaborative design tool. Perfect for UI/UX designers and product teams.<br /><br />This course covers everything from basic shapes to advanced prototyping. You'll learn to create interactive designs and collaborate effectively.<br /><br />CAD DESK provides expert training, lifetime access to materials, and certification to advance your design career."
    },
    
    sidebarImage: "img/figma.webp"
  };

  return <CoursePage {...figmaContent} />;
};

// For HTML5 Course
export const HTML5 = () => {
  const htmlContent = {
    courseTitle: "HTML5",
    courseDescription: "Learn HTML5 to build structured and semantic web pages for modern websites.",
    breadcrumbText: "HTML 5",
    
    courseContents: [
      { 
        id: 1, 
        title: "HTML Basics", 
        items: [
          "Introduction to HTML",
          "Document Structure",
          "Text Elements",
          "Lists and Links"
        ] 
      },
      { 
        id: 2, 
        title: "Multimedia", 
        items: [
          "Images",
          "Audio and Video",
          "Iframes",
          "Canvas Basics"
        ] 
      },
      { 
        id: 3, 
        title: "Forms and Tables", 
        items: [
          "Form Elements",
          "Input Types",
          "Form Validation",
          "Tables"
        ] 
      },
      { 
        id: 4, 
        title: "Semantic HTML", 
        items: [
          "Semantic Elements",
          "Accessibility",
          "SEO Basics",
          "Best Practices"
        ] 
      }
    ],
    
    courseOverview: {
      title: "HTML5 Overview",
      description: "<b>Build the structure of the web.</b> Learn HTML5 from scratch. Create semantic, accessible, and SEO-friendly web pages.<br /><br />This comprehensive course covers everything from basic tags to advanced multimedia. You'll build real websites and understand modern HTML practices.<br /><br />CAD DESK provides hands-on training, lifetime access to resources, and certification to start your web development journey."
    },
    
    sidebarImage: "img/html5.webp"
  };

  return <CoursePage {...htmlContent} />;
};

// For C++ Programming Course
export const CppProgramming = () => {
  const cppContent = {
    courseTitle: "C++ Programming",
    courseDescription: "Learn object-oriented programming, data structures, and application development using C++.",
    breadcrumbText: "C++ Programming",
    
    courseContents: [
      { 
        id: 1, 
        title: "Introduction to C++", 
        items: [
          "Concepts of Object-Oriented Programming",
          "Benefits of OOP",
          "What is C++",
          "Structure of C++ Program",
          "Creating the Source File",
          "Compiling and Linking"
        ] 
      },
      { 
        id: 2, 
        title: "Variables & Data Types", 
        items: [
          "Keywords & Identifiers",
          "Data Types",
          "Type Compatibility",
          "Variable Declaration",
          "Dynamic Initialization of Variables"
        ] 
      },
      { 
        id: 3, 
        title: "Classes & Objects", 
        items: [
          "Specifying a Class",
          "Defining Member Functions",
          "Making an Outside Function Inline",
          "Nesting of Member Functions",
          "Private Member Functions",
          "Arrays within a Class",
          "Memory Allocation for Objects",
          "Static Data Members",
          "Arrays of Objects"
        ] 
      },
      { 
        id: 4, 
        title: "Operators & Expressions", 
        items: [
          "Operators in C++",
          "Scope Resolution Operator",
          "Member Dereferencing Operators",
          "Memory Management Operators",
          "Manipulators",
          "Type Cast Operator",
          "Expressions and Types of Expressions",
          "Special Assignment Expressions",
          "Implicit Conversions",
          "Operator Precedence"
        ] 
      },
      { 
        id: 5, 
        title: "Control Structures & Functions", 
        items: [
          "Control Structures",
          "Functions in C++",
          "Function Prototyping",
          "Call by Reference",
          "Return by Reference",
          "Inline Functions",
          "Default Arguments",
          "Recursion",
          "Function Overloading",
          "Friend and Virtual Functions"
        ] 
      },
      { 
        id: 6, 
        title: "Constructors & Destructors", 
        items: [
          "Constructors",
          "Parameterized Constructors",
          "Multiple Constructors in a Class",
          "Constructors with Default Arguments",
          "Dynamic Initialization of Objects",
          "Copy Constructor",
          "Dynamic Constructors",
          "Destructors"
        ] 
      },
      { 
        id: 7, 
        title: "Inheritance", 
        items: [
          "Defining Derived Classes",
          "Single Inheritance",
          "Types of Inheritance",
          "Virtual Base Classes",
          "Abstract Classes",
          "Constructors in Derived Classes",
          "Member Classes"
        ] 
      },
      { 
        id: 8, 
        title: "Operator Overloading", 
        items: [
          "Defining Operator Overloading",
          "Overloading Unary Operators",
          "Overloading Binary Operators",
          "Manipulation of Strings using Operators",
          "Rules of Operator Overloading",
          "Type Conversion"
        ] 
      },
      { 
        id: 9, 
        title: "Exception Handling", 
        items: [
          "Basics of Exception Handling",
          "Exception Handling Mechanism",
          "Throwing Mechanism",
          "Caching Mechanism"
        ] 
      }
    ],
    
    courseOverview: {
      title: "C++ Overview",
      description: "<b>C++ was developed by Bjarne Stroustrup as an extension to C,</b> with a vision of providing high-level features and increasing the efficiency of program organization. C++ is an (OOP) Object-Oriented Programming language which is the world's most popular programming language used for developing applications, and operating systems, etc. CAD DESK being the leading brand in India provides the best quality online training course which gives a comprehensive overview of the C++ language along with the usage of OOPS concepts, classes, and objects, etc.<br /><br />Being an intermediate-level language, C++ includes features of both high-level and low-level languages. C++ programming has a variety of library support available and is simple to use. C++ programs are faster in execution. CAD DESK gives a boost to students' careers and encourages them to do Internships and provides project training are provided on the latest version of C++.<br /><br />Furthermore, CAD DESK offers students to have free lifetime access to recorded video tutorials and login access to their student dashboard. Along with that students also get the offline revision classes or practice coaching sessions to any of our franchise centers, even after course completion. CAD DESK certificates are highly recognized in the industry and it gives rise to multiple job prospects and technologies for the students."
    },
    
    sidebarImage: "img/cpp.webp"
  };

  return <CoursePage {...cppContent} />;
};

// For C# Programming Course
export const CSharpProgramming = () => {
  const csharpContent = {
    courseTitle: "C# Programming",
    courseDescription: "Learn C# programming for building desktop applications, web applications, and .NET software.",
    breadcrumbText: "C# Programming",
    
    courseContents: [
      { 
        id: 1, 
        title: "Introduction to .NET Framework", 
        items: [
          "Introduction to the Object-Oriented Approach",
          "Creating Objects",
          "Operators and Programming Constructs"
        ] 
      },
      { 
        id: 2, 
        title: "Encapsulation and Abstraction", 
        items: [
          "Creating Value Types and Reference Types",
          "Constructors and Destructors"
        ] 
      },
      { 
        id: 3, 
        title: "Advanced OOP Concepts", 
        items: [
          "Polymorphism",
          "Inheritance"
        ] 
      },
      { 
        id: 4, 
        title: "File Input and Output", 
        items: [
          "File I/O Operations",
          "Exception Handling"
        ] 
      },
      { 
        id: 5, 
        title: "Advanced C# Features", 
        items: [
          "Creating Multithreaded Applications",
          "Delegates and Events",
          "Attributes and Reflection"
        ] 
      }
    ],
    
    courseOverview: {
      title: "C# Overview",
      description: "<b>C# is a powerful and flexible programming language,</b> which is designed and developed by Microsoft. Like all programming languages, it can be used to create a variety of applications. C# is a high-level language which makes it quite easy to learn. CAD DESK's online training course gives an exclusive knowledge about .NET Framework and other OOP features like Polymorphism, Inheritance, and many more.<br /><br />C# programming language is an object-oriented programming language that makes development and maintenance easier as compare to procedural-based programming. The C# programming language provides strong memory backup and due to this the system never hanged up during the execution. CAD DESK always gives priority to providing the best online training with great quality to its students along with software internships and projects for the same.<br /><br />In addition, CAD DESK students get free lifetime access to recorded video tutorials and login access to their student dashboard; and also, they can visit any of our CAD centers for offline coaching or revision session. CAD DESK certificate facilitates its students to escalate their career, increase their level of expertise, and help them to grab the best job opportunities in the industry."
    },
    
    sidebarImage: "img/csharp.webp"
  };

  return <CoursePage {...csharpContent} />;
};